export type CapabilityGuardrail = {
  readonly write?: boolean;
  readonly approval?: boolean;
  readonly manage?: boolean;
  readonly masterScope?: boolean;
  readonly submit?: boolean;
  readonly ownerOnly?: boolean;
};

export type CapabilityDefinition = CapabilityGuardrail & {
  readonly code: string;
  readonly label: string;
};

export type CapabilityCatalog = Record<string, CapabilityDefinition[]>;

// Catalogo V1 registrado en backend (Doc: "Capabilities registradas (V1)").
// No inventar capabilities: el backend es el oráculo (invalid_capability).
export const CAPABILITY_CATALOG_V1: CapabilityCatalog = {
  Dashboard: [
    { code: "dashboard.view.basic", label: "View Basic Dashboard" },
    { code: "dashboard.manage", label: "Manage Dashboard", manage: true },
  ],
  "Work Orders": [
    { code: "work_orders.view", label: "View Work Orders" },
    { code: "work_orders.create", label: "Create Work Orders", write: true },
    {
      code: "work_orders.execute",
      label: "Execute Work Orders",
      write: true,
      submit: true,
    },
    {
      code: "work_orders.approve",
      label: "Approve Work Orders",
      approval: true,
      write: true,
    },
    {
      code: "work_orders.transfer_execution",
      label: "Transfer Execution",
      write: true,
    },
    {
      code: "work_orders.delete",
      label: "Delete Work Orders",
      write: true,
      manage: true,
    },
  ],
  Forms: [
    { code: "forms.view", label: "View Forms" },
    {
      code: "forms.execute",
      label: "Execute Forms",
      write: true,
      submit: true,
    },
    { code: "forms.manage", label: "Manage Forms", write: true, manage: true },
  ],
  Assets: [
    { code: "assets.view", label: "View Assets" },
    {
      code: "assets.manage",
      label: "Manage Assets",
      write: true,
      manage: true,
    },
  ],
  Sites: [
    { code: "sites.view", label: "View Sites" },
    {
      code: "sites.manage",
      label: "Manage Sites",
      write: true,
      manage: true,
      masterScope: true,
    },
  ],
  Library: [
    {
      code: "library.install",
      label: "Install Library Content",
      write: true,
      manage: true,
      ownerOnly: true,
    },
  ],
  Incidences: [
    { code: "incidences.view", label: "View Incidences" },
    {
      code: "incidences.manage",
      label: "Manage Incidences",
      write: true,
      manage: true,
    },
  ],
  Workflows: [
    { code: "workflows.view", label: "View Workflows" },
    {
      code: "workflows.manage",
      label: "Manage Workflows",
      write: true,
      manage: true,
    },
  ],
};

export const ALL_CAPABILITY_CODES_V1: readonly string[] = Object.values(
  CAPABILITY_CATALOG_V1,
).flatMap((caps) => caps.map((cap) => cap.code));

export function getCapabilityDefinition(
  code: string,
): CapabilityDefinition | undefined {
  for (const caps of Object.values(CAPABILITY_CATALOG_V1)) {
    const found = caps.find((cap) => cap.code === code);
    if (found) return found;
  }
  return undefined;
}
